
// import React, { useState, useEffect } from 'react';
// import axios from "axios";
// import base64 from "base-64"
// import moment from 'moment';
// import { Container, Button, ButtonGroup } from "reactstrap"
// import { useHistory } from "react-router-dom";

// //child components
// import Navbar from './Navbar'
// import Footer from './Footer'
// import GoogleMap from './GoogleMap'
// import MapForm from './MapForm'
// import Sortby from './Sortby'
// import SearchBar from './SearchBar';
// import ScrollButton from './ScrollButton'
// import SummaryHeader from './SummaryHeader';
// import DateRangeComponent from './DateRangeComponent';
// import IdleMonitor from './userAutoLogout'; //session management

// //css
// import '../assests/css/dashboard.css'

// //icons
// import HomeIcon from '../assests/icons/home.svg';
// import u from '../assests/icons/u.svg';
// import ufilled from '../assests/icons/u(filled).svg';
// import dollar from '../assests/icons/dollar.svg';
// import dollarfilled from '../assests/icons/dollar(filled).svg';
// import HomeIcon2 from '../assests/webicons/homefilled.svg';
// import BriefCase from '../assests/webicons/briefcase.svg';
// import BriefCase2 from '../assests/webicons/briefcase-filled.svg';
// import { FaSpinner } from 'react-icons/fa';

// //tool-tip
// import Tooltip from 'rc-tooltip';
// import 'rc-tooltip/assets/bootstrap.css';

// //toaster popup
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// //api calls
// import useFetchGet from '../services/getFetchApi';      //for activity data
// import summaryHomeApi from '../services/summaryHomeApi';

// const { useRef } = React;

// function Dashboard() {
//     const childRef = useRef();
//     const history = useHistory();
//     const [rSelected, setrSelected] = useState("groupByDate");
//     const [sortBy, setSortBy] = useState("groupByDate");
//     const [groupedData, setGroupedData] = useState("");
//     const [searchStatus, setSearchStatus] = useState(false);
//     const [loading, setLoading] = useState(true);
//     const [sorting, setSorting] = useState(true);
//     const [search, setsearch] = useState("groupByDate");

//     const [filterClassification, setFilterClassification] = useState(false);
//     const [allChecked, setAllChecked] = useState(false)
//     const [cardChecked, setCardChecked] = useState(false)
//     const [perCard, setPerCard] = useState([])
//     const [data, setData] = useState([]); 
//     const [dataForForm, setDataForForm] = useState([]);
//     const [dateForGroup, setDateForGrouped] = useState("");
//     const [childCardIds, setChildCardIds] = useState([])
//     const [afterSubmitSort, setAfterSubmitSort] = useState("groupByDate")
//     const [summaryData, setSummaryData] = useState({})
//     const [activityCard, setActivityCard] = useState([])

//     const [categoryFromSummary, setCategoryFromSummary] = useState(['U', 'P', 'W', 'Y'])
//     const defaultBtnStyle = "secondary";
//     const [searchVal, setSearchVal] = useState("");
//     const [emptysearchdata, setemptysearchdata] = useState(false)
//     const [emptysearchdata1, setemptysearchdata1] = useState(false)
//     const [data1, setdata1] = useState(false)

//     const toastId = React.useRef(null);

//     //get activities API call

//     const param = `${moment(localStorage.getItem('start-date'), 'MM/DD/YYYY').format("YYYYMMDD")}/${moment(localStorage.getItem('end-date'), 'MM/DD/YYYY').format("YYYYMMDD")}`;
//     const { response, isLoading, error, doFetch } = useFetchGet('UserActiviesWeb', param);
//     const { summaryResponse, isSummaryLoading, summaryError, doFetchSummary } = summaryHomeApi('UserActiviesSummary', param)
//     useEffect(() => {
//         if (response?.success === 'true') {
//             setData(response.data)
//             onRadioBtnClick("groupByDate", response.data);
//             setLoading(false);

//             //on submit of activity form
//             if (childCardIds.length > 0 && dateForGroup.length === 0) {
//                 onRadioBtnClick(afterSubmitSort, response.data)
//                 setPerCard(childCardIds.map(e => data.filter(x => e === x.id))[0])
//                setSortBy(afterSubmitSort);
//                 setrSelected(afterSubmitSort);
//             } else {
//                 if (dateForGroup.length !== 0) onRadioBtnClick(afterSubmitSort, response.data)
//             }
//             if (dateForGroup.length !== 0 && childCardIds.length === data.length && !loading) {
//                 // console.log("all result selected......")
//                 setAllChecked(true)
//             }

//         } else {
//             if (response?.errorMsg === "Invalid_SecureToken") {
//                 toast.error("Session expired, Please login again")
//                 history.push('/')
//             }
//         }
//     }, [response, isLoading, emptysearchdata1]);

//     useEffect(() => {

//         if (summaryResponse?.success === 'true') {

//             setSummaryData(summaryResponse.data)
//         } else {
//             if (summaryResponse?.errorMsg === "Invalid_SecureToken") {
//                 toast.error("Session expired, Please login again")
//                 history.push('/')
//             }
//         }
//     }, [summaryResponse, isSummaryLoading]);

//     // update category API function definition
//     const updateActivity = (payload) => {
//         Promise.all([
//             localStorage.getItem('userId'),
//             localStorage.getItem('sToken')
//         ]).then(async (res) => {
//             let userId = JSON.parse(res[0]);
//             let sToken = JSON.parse(res[1]);
//             let header = base64.encode(`${userId}:${sToken}`);
//             let security = `Basic ${header}`;

//             const options = {
//                 headers: {
//                     'Accept': 'application/json',
//                     'Security': security,
//                     'Content-Type': 'application/json',
//                 }

//             };

//             // let updateUrl = `https://uat.locusb.com/JobTracking/UpdateActivity`
//             axios.post(process.env.REACT_APP_API_PATH + 'UpdateActivity', payload, options)
//                 .then(response => {
//                     if (response.data.success === "true") {
//                      //   console.log("updated successfully", response.data)
//                         //      sortGroupData(!sorting)
//                      //   console.log("hellllllllloo-----------------------------------")
//                     }
//                     else {
//                         if (response.data.errorMsg === "Invalid_SecureToken") {
//                             toast.error("Session expired, Please login again")
//                             history.push('/')
//                             console.log("invalid secure token")
//                         }
//                         else console.log("something went wrong in update activity API", response.data.errorMsg)
//                     }
//                 }).catch(err => {
//                     console.log("error from update activity api", err)
//                 })

//         }).catch((err) => {
//             console.log("err", err)
//         })
//     }
//     var flagdata;

//     //individual card check / uncheck
//     const perDataCard = (detail) => {

//         setAllChecked(false)
//         setDateForGrouped("")
//         setDataForForm([])
//         setCardChecked("")
//         if (perCard.some(obj => obj.id === detail.id) || childCardIds.includes(detail.id)) {
//             // console.log("same card clicked")
//             setPerCard(perCard.filter(e => e.id !== detail.id))
//             setChildCardIds(childCardIds.filter(e => e !== detail.id))
//         } else {
//             setPerCard(oldArray => [...oldArray, detail]);
//             setChildCardIds(oldArray => [...oldArray, detail.id])
//         }
//     }

//     //checking same cards selections
//     const objectsAreSame = (param, dataForForm) => {
//         for (var propertyName in param) {
//             if (dataForForm?.length === 0 && param[propertyName] !== dataForForm[propertyName]) {
//                 return false;
//             }
//             else return true;
//         }
//     }

//   //  console.log("search",search)
//     //check / uncheck card
//     const checkingCard = (param) => {
//         setPerCard([]);
//         setChildCardIds([]);
//         if (objectsAreSame(param?.data, dataForForm)) {
//             setDateForGrouped("")
//             setDataForForm([])
//             setCardChecked("")
//             setChildCardIds([]);
//         } else {
//             setDataForForm(param.data)
//             if (param === "all") {
//                 setAllChecked(!allChecked)
//                 var users = groupedData.map(o => o.data).flat();
//                 if (allChecked) {
//                     setDataForForm([])
//                     setChildCardIds([])
//                     setPerCard([])
//                     setDateForGrouped("")
//                 }
//                 else {
//                     setDataForForm(users)
//                     setPerCard([])
//                     setChildCardIds(users.map((e) => e.id))
//                 }
//             }
//             else {
//                 if (cardChecked === param.date || dateForGroup === param.date) {
//                     setCardChecked("")
//                     setChildCardIds([])
//                 } else {
//                     setCardChecked(param.date)
//                     if (sortBy === "groupByDate" && param !== "all") {
//                         setAllChecked(false)
//                         setDateForGrouped(param.date)
//                     } else {
//                         if (sortBy === "groupByCustomer" && param !== "all") {
//                             setDateForGrouped(param.date)
//                         } else {
//                             if (sortBy === "groupByAddress" && param !== "all") {
//                                 setDateForGrouped(param.date)
//                             } else {
//                                 setDateForGrouped(param.date)
//                             }
//                         }
//                     }
//                 }
//                 setChildCardIds(param.data.map(itm => itm.id))
//             }
//         }
//     }
//     localStorage.setItem('sort',sorting)
//     const myFun = async (value, btnData) => {
//         if (value === "Billable") {
//             if (btnData.classification === "W" || btnData.classification === "Work") {
//                 await myFun2(value, btnData);
//                 await myFun1();

//             }
//             else {
//                 await myFun2(value, btnData);
//             }
//         } else {
//             await myFun2(value, btnData);
//             await myFun1();
//         }

//     }

//     const myFun1 = async () => {
//         setTimeout(function () {
//             doFetchSummary();
//         }, 1000)
//     }
//     const myFun2 = async (value, btnData) => {
// //console.log("value",value);
// //console.log("btnData",btnData)
//         var clonedArray = [...data];
//      //   console.log("clonedArray",clonedArray);

//         if (value === "Billable") {
//             if (btnData.classification === "W" || btnData.classification === "Work") {
//                 clonedArray.filter((item) => {
//                     if (item.id === btnData.id) {
//                         item.selected = "W";
//                         item.classification = "W";
//                         item.billable = btnData.billable === "N" ? "Y" : "N";
//                     }
//                 })
//                 setData(clonedArray);
//                 var reqData1 = {
//                     activityId: btnData.id,
//                     customerId: btnData.customerId,
//                     classification: "W",
//                     billable: btnData.billable
//                 }
//              //   console.log("reqData1",reqData1)

//                 updateActivity(reqData1);
//              //   setPerCard([btnData]);
//                 // console.log("btndata.id", btnData.id)
//                // setChildCardIds([btnData.id]);
//             }
//             else {
//                 if (!toast.isActive(toastId.current)) {
//                     toastId.current = toast.warn(`Only a 'Work' type visit can be classified as 'Billable'`);
//                 }
//             }
//         } else {
//             clonedArray.filter((item) => {
//                 if (item.id === btnData.id) {
//                     item.selected = value;
//                     item.classification = value;
//                 }
//             })
//             setData(clonedArray);
//             var reqData = {
//                 activityId: btnData.id,
//                 customerId: btnData.customerId,
//                 classification: value.charAt(0),
//                 billable: btnData.billable
//             }
//          //   console.log("reqData",reqData)
//             updateActivity(reqData);
//           //  setPerCard([btnData]);
//             // console.log("btndata.id", btnData.id)
//           //  setChildCardIds([btnData.id]);

//         }
//     }
// //
// const handleSearchChange1 = async (p) => {
//     setFilterClassification(true)
//       setSearchStatus(true);
//       //console.log(localStorage.getItem('searchItem'));
//       if (localStorage.getItem('searchItem')) {
//           var tempArray = await filterResToGroupnew(p);
//          // console.log("tempArray1", tempArray)
//           var value = localStorage.getItem('searchItem')
//           setSearchVal(value)
//          // console.log("value", value)
//          // console.log("tempArray2", tempArray)
//           var newArray = [];
//           //search filter
//           const result = tempArray.filter(obj => {
//               obj.data = obj.data.filter(subElement => subElement.customerName.toLowerCase().search(value.toLowerCase()) !== -1 || subElement.formattedAddress.toLowerCase().search(value.toLowerCase()) !== -1 || subElement.formattedDate.toLowerCase().search(value.toLowerCase()) !== -1);
//               if (obj.data.length > 0) {
//                   //if category selected and search (match selected category with data classification)
//                       obj.data = obj.data.filter(subElement => (categoryFromSummary.includes(subElement.classification) || categoryFromSummary.includes(subElement.billable)));

//                       if (obj.data.length > 0) {
//                           // console.log(obj);
//                          return newArray.push(obj)

//                   }
//               }
//           })
//          // console.log(result);
//           setActivityCard(result);
//           setGroupedData(result);

//       }

//   }

// //

//     //groupby functionality

//     const onRadioBtnClick = async (p, array) => {
//        // console.log("p",p)
//         setemptysearchdata(!emptysearchdata)
//         setAllChecked(false);
//         setCardChecked(false);
//         var newData = array;
//         setrSelected(p)
//         setSortBy(p)
//         setAfterSubmitSort(p);

//         const newGroupedData = groupBy(newData, p);
//         var tempArray = [];
//         if (newGroupedData && newGroupedData !== undefined) {
//             for (const [key, value] of Object.entries(newGroupedData).sort()) {
//                 let obj = {
//                     date: key, //name/date/address
//                     data: value // array of obj
//                 }
//                 tempArray.push(obj);
//             }
//             setGroupedData(tempArray)
//             setActivityCard(tempArray)

//         }
//      //   handleSearchChange1(p);

//     }

//     const sortGroupData = async (sort) => {
//        // console.log("sort", sort)
//         //   alert("hello");
//         setSorting(sort);
//         //    setTimeout(()=>{
//       //  console.log(groupedData)
//         var newGroup = [...groupedData];
//       //  console.log("newGroup", newGroup)

//         const sortedGroup = newGroup.sort((b, a) => { return a.date - b.date; }).reverse();
//         setGroupedData(sortedGroup);
//         setActivityCard(sortedGroup);
//       //  console.log("sortedGroup", sortedGroup)
//         //   },3000)
//         setLoading(false);
//     }

//     //grouping of cards by name, date, address
//     function groupBy(objectArray, property) {
//         if (objectArray && objectArray.length > 0) {
//             return objectArray.reduce((acc, obj) => {
//                 const key = obj[property];
//                 if (!acc[key]) {
//                     acc[key] = [];
//                 }
//                 // Add object to list for given key's value
//                 acc[key].push(obj);
//                 return acc;
//             }, {});
//         }
//     }

//     //on selecting date range from datepicker
//     const handleDateRange = (event, dates) => {
//         //     console.log("dates",dates);
//         filterCategory([]);
//         setLoading(true);
//         setAllChecked(false);
//         setCardChecked(false);
//         setPerCard([]);
//         localStorage.setItem('start-date', moment(dates.startDate).format('MM/DD/YYYY'))
//         localStorage.setItem('end-date', moment(dates.endDate).format('MM/DD/YYYY'))

//         doFetch();
//         doFetchSummary();
//         setLoading(false);
//     }


//     //search functionality
//     const handleSearchChange = async (e) => {
//       //  console.log("e",e);     
//         var value = e;
//         setSearchVal(e)
//         var tempArray = await filterResToGroup();

//         if (value.length === 0 && (categoryFromSummary.length === 4 || categoryFromSummary.length === 0)) {
//             setSearchStatus(false);
//             setActivityCard(tempArray);
//             setGroupedData(tempArray)

//         } else {
//             var newArray = [];

//             //search filter
//             tempArray.filter(obj => {
//                 obj.data = obj.data.filter(subElement => subElement.customerName.toLowerCase().search(value.replace(/&(lt|gt|quot|=);\\/g, "").toLowerCase()) !== -1 || subElement.formattedAddress.toLowerCase().search(value.replace(/&(lt|gt|quot|=);\\/g, "").toLowerCase()) !== -1);
//                 if (obj.data.length > 0) {
//                     //if category selected and search (match selected category with data classification)
//                     if (filterClassification) {
//                         obj.data = obj.data.filter(subElement => (categoryFromSummary.includes(subElement.classification) || categoryFromSummary.includes(subElement.billable)));
//                         if (obj.data.length > 0) {
//                             newArray.push(obj)
//                         } else return;
//                     }
//                     else newArray.push(obj);
//                 }
//             })
//           //  console.log("newArray",newArray)
//             setActivityCard(newArray);
//             setGroupedData(newArray);

//         }

//     }

//     //called after updating activity data child form
//     const feedbackFun = (selectdata, sorting) => {
//         doFetch()
//         doFetchSummary();

//         setAfterSubmitSort(sorting)
//         if (childCardIds.length === data.length) {
//             // console.log("all result selected......")
//             setAllChecked(true)
//         }
//         childRef.current.getAlert();
//     }

//     // filtering data by summary category button

//     const filterCategory = async (category) => {
//         setAllChecked(false);
//         setCardChecked(false);
//         setPerCard([]);
//         setDataForForm([]);
//         setChildCardIds([]);
//         setActivityCard([])
//         var value = localStorage.getItem('searchItem');

//       //  console.log("category.length",category.length);
//         var newTempArray = [];
//         var newArray = [];
//         if (category.length === 0 || category.length === 4) {
//             setCategoryFromSummary(['U', 'P', 'W', 'Y']);

//             var tempArray = await filterResToGroup();

//             if(localStorage.getItem('searchItem')){
//                 console.log("tempArray",tempArray);
//                 tempArray.filter(obj => {
//                     obj.data = obj.data.filter(subElement => subElement.customerName.toLowerCase().search(value.replace(/&(lt|gt|quot|=);\\/g, "").toLowerCase()) !== -1 || subElement.formattedAddress.toLowerCase().search(value.replace(/&(lt|gt|quot|=);\\/g, "").toLowerCase()) !== -1);
//                     if (obj.data.length > 0) {
//                         //if category selected and search (match selected category with data classification)
//                         console.log("categoryFromSummarybefore",categoryFromSummary);

//                         if (!filterClassification) {           
//                             obj.data = obj.data.filter(subElement => (categoryFromSummary.includes(subElement.classification) || categoryFromSummary.includes(subElement.billable)));
//                             if (obj.data.length > 0) {
//                                 newArray.push(obj)
//                             } else return;
//                         }
//                         else newArray.push(obj);
//                     }
//                 })
//          console.log("1",newArray)
//                 setGroupedData(newArray)
//                 setActivityCard(newArray)
//             }else {
//                 console.log("2",tempArray)

//                 setGroupedData(tempArray)
//                 setActivityCard(tempArray)
//             }
//         } else {
//             setCategoryFromSummary(category);
//             setFilterClassification(true)
//             var tempArray = await filterResToGroup();
//                     console.log("tempArray",tempArray)
//             tempArray.filter(obj => {
//                 obj.data = obj.data.filter((subElement) =>
//                     category.indexOf(subElement.classification) !== -1 || category.indexOf(subElement.billable) !== -1
//                 );
//                 if (obj.data.length > 0) {
//                     newTempArray.push(obj);
//                 } else return;


//             });
//             console.log("newTempArray",newTempArray)

//             if(localStorage.getItem('searchItem')){
//              var   newarrayforsearch =[];

//              console.log("newTempArray",newTempArray);
//         newTempArray.filter(obj => {
//                 obj.data = obj.data.filter(subElement => subElement.customerName.toLowerCase().search(value.replace(/&(lt|gt|quot|=);\\/g, "").toLowerCase()) !== -1 || subElement.formattedAddress.toLowerCase().search(value.replace(/&(lt|gt|quot|=);\\/g, "").toLowerCase()) !== -1);
//                 if (obj.data.length > 0) {
//                     console.log("categoryFromSummary",categoryFromSummary);
//                   console.log("category.length",category.length);

//                  //if category selected and search (match selected category with data classification)
//                     if (filterClassification) {
//                         obj.data = obj.data.filter(subElement => (categoryFromSummary.includes(subElement.classification) || categoryFromSummary.includes(subElement.billable)));
//                         if (obj.data.length > 0) {
//                             newarrayforsearch.push(obj)
//                         } else return;
//                     }
//                     else newarrayforsearch.push(obj);
//                 }
//             })
//             newTempArray.filter(obj => {
//                 obj.data = obj.data.filter((subElement) =>
//                     category.indexOf(subElement.classification) !== -1 || category.indexOf(subElement.billable) !== -1
//                 ); 
//                 if (obj.data.length > 0) {
//                     console.log("obj.data",obj.data)
//                    newarrayforsearch.push(obj);
//                 } else return;

//           console.log("newarrayforsearch",newarrayforsearch);

//             });
//             setGroupedData(newarrayforsearch)
//             setActivityCard(newarrayforsearch)
//         }else {
//             setGroupedData(newTempArray)
//             setActivityCard(newTempArray)
//         }
//         }
//     }

//     const filterResToGroup = async () => {
//      //   console.log("sortBy",sortBy)
//      //   console.log("search",search)
//         var newData = data;
//         const newGroupedData = await groupBy(newData, search);
//         var tempArray = [];
//         if (newGroupedData && newGroupedData !== undefined) {
//             for (const [key, value] of Object.entries(newGroupedData).sort()) {
//                 let obj = {
//                     date: key,
//                     data: value
//                 }
//                 tempArray.push(obj);
//             }
//         }
//         return tempArray;
//     }
//     const filterResToGroupnew = async (p) => {
//         //   console.log("sortBy",sortBy)
//         //   console.log("search",search)
//            var newData = data;
//            const newGroupedData = await groupBy(newData, p);
//            var tempArray = [];
//            if (newGroupedData && newGroupedData !== undefined) {
//                for (const [key, value] of Object.entries(newGroupedData).sort()) {
//                    let obj = {
//                        date: key,
//                        data: value
//                    }
//                    tempArray.push(obj);
//                }
//            }
//            return tempArray;
//        }
//     return (
//         <div className="dashmaindiv" style={{ fontFamily: "Poppins" }}>
//             <div style={{ width: "100%" }}>

//                 <Navbar />

//                 <Container fluid="true" style={{ alignItems: "center", justifyContent: "center", padding: "0px" }} className="containerStyle bg-white mx-auto">

//                     <div className="filterDiv row">
//                         {/* Date range picker*/}
//                         <DateRangeComponent isLoading={isLoading} handleDateRange={handleDateRange} />

//                         {/* Grouping button group */}
//                         <div className="col-md-6 my-auto pr-5 text-end">
//                             <small>&nbsp;Group By &nbsp;
//                                 <ButtonGroup size="sm">
//                                     <Button className="LeftBtnStyle ActiveBtnStyle" outline color={defaultBtnStyle} onClick={() => { onRadioBtnClick("groupByDate", data);  }}  active={rSelected === "groupByDate"}>Date</Button>
//                                     <Button className="ActiveBtnStyle" outline color={defaultBtnStyle} onClick={() => { onRadioBtnClick("groupByCustomer", data); setPerCard([]);  }} active={rSelected === "groupByCustomer"}>Name</Button>
//                                     <Button className="RightBtnStyle ActiveBtnStyle" outline color={defaultBtnStyle} onClick={() => { onRadioBtnClick("groupByAddress", data);   }} active={rSelected === "groupByAddress"}>Address</Button>
//                                 </ButtonGroup>
//                             </small>
//                         </div>

//                         {/* summary hours block */}
//                         <SummaryHeader summaryData={summaryData} isSummaryLoading={isSummaryLoading} filterCategory={filterCategory} filterClassification={filterClassification} />

//                     </div>

//                     {/* mapping of card data */}
//                     <div className="row" style={{ margin: "0 0 2.5rem 0", fontWeight: "300" }}>
//                         {(loading || data.length === 0 || !data) ?
//                             <div className="loadNoDataDiv" style={{ fontSize: "x-large", fontWeight: "bolder" }}>{(!loading && activityCard.length === 0 && groupedData.length === 0) ? "No data available" : <span style={{ color: "#2596BE" }}>
//                                 <FaSpinner icon="spinner" spin={"true"} style={{ animation: "spin infinite 5s linear" }} />&nbsp;
//                                 Loading...</span>}
//                             </div>
//                             : <>
//                                 <div className="col-md-9" style={{ padding: "0px", backgroundColor: "#ebe7e7" }}>

//                                     {/* SearchBar */}
//                                     <SearchBar handleSearchChange={handleSearchChange} emptygroup={emptysearchdata} category={categoryFromSummary} />

//                                     {((data && data.length > 0 && groupedData && groupedData.length > 0) || (searchStatus && activityCard && activityCard.length > 0) && !loading) ?
//                                         <>
//                                             <div className="row" style={{ border: "1px solid lightgrey", paddingBlock: "5px", margin: "0px", backgroundColor: "white", alignSelf: 'center !important' }}>

//                                                 {/* all result checkbox */}
//                                                 <div className="col p-0">
//                                                     <small style={{ marginLeft: "10px", verticalAlign: "middle" }}>
//                                                         <input type="checkbox" onChange={() => { checkingCard("all"); setPerCard([]); setCardChecked(false); }} checked={allChecked} />
//                                                         &nbsp;All results
//                                                     </small>
//                                                 </div>

//                                                 {/* Sorting the groups */}
//                                                 <div className="col p-0" onClick={() => {
//                                                     setLoading(true);
//                                                     sortGroupData(!sorting);
//                                                 }}
//                                                     className="sortByDiv"
//                                                 >
//                                                     <Sortby sortProps={sorting} />
//                                                 </div>

//                                             </div>

//                                             {/* Grouped activities */}
//                                             {data && data.length > 0 && groupedData.length > 0 && activityCard.length > 0 && activityCard.map((gdata, index) =>
//                                                 <div>
//                                                     <div key={index} style={{ backgroundColor: "#d3d3d336", border: "1px solid darkgrey", marginBlock: "2px", display: gdata?.data[0] ? '' : 'none' }}>
//                                                         {/* group header */}
//                                                         <div style={{ fontSize: "12.8px", padding: "5px 1px", display: "flex", placeContent: "space-between", backgroundColor: "#f7f7f7" }}>

//                                                             <span key={gdata.date} style={{ paddingLeft: "6px", color: "#2596BE", borderRight: "1px solid lightrey" }} >
//                                                                 <label className="customCheck">&nbsp;&nbsp;{(sortBy === "groupByDate") ? moment(gdata.date).format('dddd, MMM DD, YYYY') : gdata.date}
//                                                                     <input type="checkbox" style={{ verticalAlign: "middle" }} onChange={() => { checkingCard(gdata) }} checked={allChecked || (gdata.date === (cardChecked || dateForGroup))} />
//                                                                      <span className="checkmark"></span>
//                                                                 </label>
//                                                             </span>

//                                                             <span style={{ paddingRight: "1rem", fontWeight: "bold", marginBlock: "auto" }}>(Duration Total - {sortBy === "groupByCustomer" ? gdata?.data[0]?.hoursByCustomer : [sortBy === "groupByDate" ? gdata?.data[0]?.hoursByDate : gdata?.data[0]?.hoursByAddress]})</span>
//                                                         </div>


//                                                         {/* Group data */}
//                                                         {gdata.data.length > 0 && gdata.data.map((item, index) => (
//                                                             <div key={index} style={{ display: "flex", borderTop: "1px solid lightgrey", padding: "2px 1px", placeContent: "space-between", backgroundColor: "white" }}>
//                                                                 {/* Group header */}
//                                                                 <div style={{ flex: sortBy === "groupByCustomer" ? 0.02 : 0.8, textAlign: "left", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "" }} className="smallFont">
//                                                                     {/* checkbox */}
//                                                                     <input type="checkbox" style={{ verticalAlign: "middle" }} onChange={() => perDataCard(item)} checked={(childCardIds.includes(item.id) || item.groupByDate === (cardChecked || dateForGroup) || item.groupByCustomer === cardChecked || item.groupByAddress === cardChecked || allChecked || perCard.some(obj => obj.id === item.id) || (perCard.includes(item.id)) ? true : false)} />
//                                                                     &nbsp;
//                                                                     {/* activity name */}
//                                                                     <span style={{ flex: .4, display: sortBy === "groupByCustomer" ? "none" : "" }}>&nbsp;{item.customerName}</span>
//                                                                 </div>

//                                                                 {/* Group data */}
//                                                                 {/* date */}
//                                                                 <div style={{ flex: .6, display: sortBy === "groupByDate" ? "none" : "" }} className="smallFont flexCss" >{moment(item.groupByDate).format('ddd, MMM DD, YYYY')}</div>
//                                                                 {/* Address */}
//                                                                 <Tooltip radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div style={{ fontSize: "x-small" }}>{item.formattedAddress}</div>}>
//                                                                     <div style={{ flex: 1.2, overflow: "hidden !important", whiteSpace: "nowrap !important", textOverflow: "ellipsis !important", cursor: "pointer", display: sortBy === "groupByAddress" ? "none" : "" }} className="smallFont flexCss" >{item.formattedAddress}</div>
//                                                                 </Tooltip>
//                                                                 {/* Time */}
//                                                                 <div style={{ flex: .8, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} className="smallFont">{item.displayTime}</div>
//                                                                 {/* Duration */}
//                                                                 <div style={{ flex: .4, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} className="smallFont"><b>{item.duration}</b></div>
//                                                                 {/* classification buttons */}
//                                                                 <div style={{ flex: sortBy === "groupByAddress" ? 0.7 : .8, display: "flex", justifyContent: "flex-end", paddingRight: "1rem" }}>
//                                                                     {/* Unclassified */}
//                                                                     {(item.classification === "U" || item.selected === "Unclassified") ?
//                                                                         <Tooltip radius="5" arrow="5" placement="bottom" overlay={<div style={{ fontSize: "x-small" }}>Unclassified</div>}>
//                                                                             <span style={{ backgroundColor: "#dcdcdc", height: "fitContent" }} className="icon-circle unclassifiedBtn btn-hover-none" onClick={() => { myFun("Unclassified", item); }}><img src={ufilled} height="20px" width="20px" alt="qmark" /><span style={{ fontSize: ".8em", fontWeight: "500" }}></span>
//                                                                             </span>
//                                                                         </Tooltip>
//                                                                         :
//                                                                         <Tooltip radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div style={{ fontSize: "x-small" }}>Unclassified</div>}>
//                                                                             <span style={{ backgroundColor: "white", height: "fitContent", border: "1px solid rgba(112, 101, 101, 0.5) " }} className="icon-circle unclassifiedBtn" onClick={() => { myFun("Unclassified", item); }} ><img src={(item?.selected === "Unclassified" && "Unclassified") ? ufilled : u} height="20px" width="20px" alt="qmark2" /><span style={{ fontSize: ".8em", fontWeight: "500" }}>{item?.selected === "Unclassified" && "Unclassified"}</span>
//                                                                             </span>
//                                                                         </Tooltip>
//                                                                     }

//                                                                     {/* Personal */}
//                                                                     {(item.classification === "P" || item.selected === "Personal") ?
//                                                                         <Tooltip radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div style={{ fontSize: "x-small" }}>Personal</div>}><span style={{ backgroundColor: "#E1EBEF", height: "fitContent" }} className="icon-circle personalBtn btn-hover-none" onClick={() => { myFun("Personal", item); }} ><img src={HomeIcon2} height="20px" width="20px" alt="home" /><span style={{ fontSize: ".8em", fontWeight: "500" }}></span></span></Tooltip>
//                                                                         :
//                                                                         <Tooltip radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div style={{ fontSize: "x-small" }}>Personal</div>}><span style={{ backgroundColor: "white", height: "fitContent", border: "1px solid rgba(13, 117, 153, 0.5)" }} className="icon-circle personalBtn" onClick={() => { myFun("Personal", item); }}><img src={item?.selected === "Personal" && "Personal" ? HomeIcon2 : HomeIcon} height="20px" width="20px" alt="home2" /><span style={{ fontSize: ".8em", fontWeight: "500" }}>{item?.selected === "Personal" && "Personal"}</span></span></Tooltip>
//                                                                     }
//                                                                     {/* Work */}
//                                                                     {(item.classification === "W" || item.selected === "Work") ?
//                                                                         <Tooltip radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div style={{ fontSize: "x-small" }}>Work</div>}><span style={{ backgroundColor: "#CAECE5", height: "fitContent" }} className="icon-circle workBtn btn-hover-none" onClick={() => { myFun("Work", item); }}><img src={BriefCase2} height="20px" width="20px" alt="work" /><span style={{ fontSize: ".8em", fontWeight: "500" }}></span></span></Tooltip>
//                                                                         :
//                                                                         <Tooltip radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div style={{ fontSize: "x-small" }}>Work</div>}><span style={{ backgroundColor: "white", height: "fitContent", border: "1px solid rgba(0, 117, 94, 0.5)" }} className="icon-circle workBtn" onClick={() => { myFun("Work", item); }}><img src={item?.selected === "Work" && "Work" ? BriefCase2 : BriefCase} height="20px" width="20px" alt="work" /><span style={{ fontSize: ".8em", fontWeight: "500" }}>{item?.selected === "Work" && "Work"}</span></span></Tooltip>
//                                                                     }
//                                                                     {/* Billable */}
//                                                                     {(item.billable === "Y") && (item.classification === "W" || item.selected === "Work") ?
//                                                                         <Tooltip radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div style={{ fontSize: "x-small" }}>Billable</div>}><span style={{ backgroundColor: "#FCEFEE", height: "fitContent" }} className=" billingBtn btn-hover-none" onClick={() => { myFun("Billable", item); }}><img src={dollarfilled} height="20px" width="20px" alt="bill" /><span style={{ fontSize: ".8em", fontWeight: "500" }}></span></span></Tooltip>
//                                                                         :
//                                                                         <Tooltip radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div style={{ fontSize: "x-small" }}>Billable</div>}><span style={{ backgroundColor: "white", height: "fitContent", border: "1px solid rgba(187, 36, 31, 0.5)" }} className=" billingBtn" onClick={() => { myFun("Billable", item); }}><img src={dollar} height="20px" width="20px" alt="bill" /></span></Tooltip>
//                                                                     }
//                                                                 </div>
//                                                             </div>
//                                                         ))}
//                                                     </div>
//                                                 </div>)
//                                             }
//                                         </>
//                                         : <div className="loadNoDataDiv" style={{ backgroundColor: 'white' }}>No data available</div>
//                                     }
//                                 </div>
//                                 <div className="col-md-3" style={{ borderRight: "1px solid lightgrey", padding: "0px" }}>
//                                     {(childCardIds?.length === 0 || childCardIds === undefined) ?
//                                         <div className="sidediv1" style={{ color: "#2596BE", textDecoration: "underline" }}><h6>Select Visit(S) To Modify</h6></div> :
//                                         <div className="sidediv2">
//                                             {/* Google map */}
//                                             <GoogleMap data={data.filter((elem) => childCardIds.find((id) => elem.id === id))?.filter(mapCoord => mapCoord.coordinate)} />
//                                             {/* Update Activity Form */}
//                                             <MapForm data={data.filter((elem) => childCardIds.find((id) => elem.id === id))} cardIDs={childCardIds} sortBy={sortBy} updateState={feedbackFun} ref={childRef} />
//                                         </div>}
//                                 </div></>}
//                     </div>

//                     <ToastContainer />
//                     <ScrollButton />
//                     <IdleMonitor />

//                 </Container>
//                 <Footer />

//             </div>

//         </div>

//     );
// }

// export default Dashboard;


import React, { useState, useEffect } from 'react';
import axios from "axios";
import base64 from "base-64"
import moment from 'moment';
import { Container, Button, ButtonGroup } from "reactstrap"
import { useHistory } from "react-router-dom";

//child components
import Navbar from './Navbar'
import Footer from './Footer'
import GoogleMap from './GoogleMap'
import MapForm from './MapForm'
import Sortby from './Sortby'
import SearchBar from './SearchBar';
import ScrollButton from './ScrollButton'
import SummaryHeader from './SummaryHeader';
import DateRangeComponent from './DateRangeComponent';
import IdleMonitor from './userAutoLogout'; //session management

//css
import '../assests/css/dashboard.css'

//icons
import HomeIcon from '../assests/icons/home.svg';
import u from '../assests/icons/u.svg';
import ufilled from '../assests/icons/u(filled).svg';
import dollar from '../assests/icons/dollar.svg';
import dollarfilled from '../assests/icons/dollar(filled).svg';
import HomeIcon2 from '../assests/webicons/homefilled.svg';
import BriefCase from '../assests/webicons/briefcase.svg';
import BriefCase2 from '../assests/webicons/briefcase-filled.svg';
import { FaSpinner } from 'react-icons/fa';

//tool-tip
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';

//toaster popup
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//api calls
import useFetchGet from '../services/getFetchApi';      //for activity data
import summaryHomeApi from '../services/summaryHomeApi';
import ENV from '../env';

const { useRef } = React;

function Dashboard() {
    const childRef = useRef();
    const history = useHistory();
    const [rSelected, setrSelected] = useState("groupByDate");
    const [sortBy, setSortBy] = useState("groupByDate");
    const [groupedData, setGroupedData] = useState("");
    const [searchStatus, setSearchStatus] = useState(false);
    const [loading, setLoading] = useState(true);
    const [sorting, setSorting] = useState(true);
    const [sorting1, setSorting1] = useState(true);

    const [filterClassification, setFilterClassification] = useState(false);
    const [allChecked, setAllChecked] = useState(false)
    const [cardChecked, setCardChecked] = useState(false)
    const [perCard, setPerCard] = useState([])
    const [data, setData] = useState([]);
    const [dataForForm, setDataForForm] = useState([]);
    const [dateForGroup, setDateForGrouped] = useState("");
    const [childCardIds, setChildCardIds] = useState([])
    const [afterSubmitSort, setAfterSubmitSort] = useState("groupByDate")
    const [summaryData, setSummaryData] = useState({})
    const [activityCard, setActivityCard] = useState([])

    const [categoryFromSummary, setCategoryFromSummary] = useState(['U', 'P', 'W', 'Y'])
    const defaultBtnStyle = "secondary";
    const [searchVal, setSearchVal] = useState("");
    const [emptysearchdata, setemptysearchdata] = useState(false)
    const [emptysearchdata1, setemptysearchdata1] = useState(false)
    const [data1, setdata1] = useState(false)

    const toastId = React.useRef(null);

    //get activities API call

    const param = `${moment(localStorage.getItem('start-date'), 'MM/DD/YYYY').format("YYYYMMDD")}/${moment(localStorage.getItem('end-date'), 'MM/DD/YYYY').format("YYYYMMDD")}`;
    const { response, isLoading, error, doFetch } = useFetchGet('UserActiviesWeb', param);
    const { summaryResponse, isSummaryLoading, summaryError, doFetchSummary } = summaryHomeApi('UserActiviesSummary', param)
    useEffect(() => {
        if (response?.success === 'true') {
            setData(response.data)
            onRadioBtnClick("groupByDate", response.data);
            setLoading(false);

            //on submit of activity form
            if (childCardIds.length > 0 && dateForGroup.length === 0) {
                onRadioBtnClick(afterSubmitSort, response.data)
                setPerCard(childCardIds.map(e => data.filter(x => e === x.id))[0])
                setSortBy(afterSubmitSort);
                setrSelected(afterSubmitSort);
            } else {
                if (dateForGroup.length !== 0) onRadioBtnClick(afterSubmitSort, response.data)
            }
            if (dateForGroup.length !== 0 && childCardIds.length === data.length && !loading) {
                // console.log("all result selected......")
                setAllChecked(true)
            }

        } else {
            if (response?.errorMsg === "Invalid_SecureToken") {
                toast.error("Session expired, Please login again")
                history.push('/')
            }
        }
    }, [response, isLoading, emptysearchdata1]);

    useEffect(() => {

        if (summaryResponse?.success === 'true') {

            setSummaryData(summaryResponse.data)
        } else {
            if (summaryResponse?.errorMsg === "Invalid_SecureToken") {
                toast.error("Session expired, Please login again")
                history.push('/')
            }
        }
    }, [summaryResponse, isSummaryLoading]);

    // update category API function definition
    const updateActivity = (payload) => {
        Promise.all([
            localStorage.getItem('userId'),
            localStorage.getItem('sToken')
        ]).then(async (res) => {
            let userId = JSON.parse(res[0]);
            let sToken = JSON.parse(res[1]);
            let header = base64.encode(`${userId}:${sToken}`);
            let security = `Basic ${header}`;

            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Security': security,
                    'Content-Type': 'application/json',
                }

            };

            // let updateUrl = `https://uat.locusb.com/JobTracking/UpdateActivity`
            axios.post(ENV.LOCUSB_API + '/UpdateActivity', payload, options)
                .then(response => {
                    if (response.data.success === "true") {
                        console.log("updated successfully", response.data)
                        //      sortGroupData(!sorting)
                        console.log("hellllllllloo-----------------------------------")
                    }
                    else {
                        if (response.data.errorMsg === "Invalid_SecureToken") {
                            toast.error("Session expired, Please login again")
                            history.push('/')
                            console.log("invalid secure token")
                        }
                        else console.log("something went wrong in update activity API", response.data.errorMsg)
                    }
                }).catch(err => {
                    console.log("error from update activity api", err)
                })

        }).catch((err) => {
            console.log("err", err)
        })
    }
    var flagdata;

    //individual card check / uncheck
    const perDataCard = (detail) => {

        setAllChecked(false)
        setDateForGrouped("")
        setDataForForm([])
        setCardChecked("")
        if (perCard.some(obj => obj.id === detail.id) || childCardIds.includes(detail.id)) {
            // console.log("same card clicked")
            setPerCard(perCard.filter(e => e.id !== detail.id))
            setChildCardIds(childCardIds.filter(e => e !== detail.id))
        } else {
            setPerCard(oldArray => [...oldArray, detail]);
            setChildCardIds(oldArray => [...oldArray, detail.id])
        }
    }

    //checking same cards selections
    const objectsAreSame = (param, dataForForm) => {
        for (var propertyName in param) {
            if (dataForForm?.length === 0 && param[propertyName] !== dataForForm[propertyName]) {
                return false;
            }
            else return true;
        }
    }

    //check / uncheck card
    const checkingCard = (param) => {
        setPerCard([]);
        setChildCardIds([]);
        if (objectsAreSame(param?.data, dataForForm)) {
            setDateForGrouped("")
            setDataForForm([])
            setCardChecked("")
            setChildCardIds([]);
        } else {
            setDataForForm(param.data)
            if (param === "all") {
                setAllChecked(!allChecked)
                var users = groupedData.map(o => o.data).flat();
                if (allChecked) {
                    setDataForForm([])
                    setChildCardIds([])
                    setPerCard([])
                    setDateForGrouped("")
                }
                else {
                    setDataForForm(users)
                    setPerCard([])
                    setChildCardIds(users.map((e) => e.id))
                }
            }
            else {
                if (cardChecked === param.date || dateForGroup === param.date) {
                    setCardChecked("")
                    setChildCardIds([])
                } else {
                    setCardChecked(param.date)
                    if (sortBy === "groupByDate" && param !== "all") {
                        setAllChecked(false)
                        setDateForGrouped(param.date)
                    } else {
                        if (sortBy === "groupByCustomer" && param !== "all") {
                            setDateForGrouped(param.date)
                        } else {
                            if (sortBy === "groupByAddress" && param !== "all") {
                                setDateForGrouped(param.date)
                            } else {
                                setDateForGrouped(param.date)
                            }
                        }
                    }
                }
                setChildCardIds(param.data.map(itm => itm.id))
            }
        }
    }
    localStorage.setItem('sort', sorting)
    const myFun = async (value, btnData) => {
        if (value === "Billable") {
            if (btnData.classification === "W" || btnData.classification === "Work") {
                await myFun2(value, btnData);
                await myFun1();

            }
            else {
                await myFun2(value, btnData);
            }
        } else {
            await myFun2(value, btnData);
            await myFun1();
        }

    }

    const myFun1 = async () => {
        setTimeout(function () {
            doFetchSummary();
        }, 1000)
    }
    const myFun2 = async (value, btnData) => {
        console.log("value", value);
        console.log("btnData", btnData)
        var clonedArray = [...data];
        console.log("clonedArray", clonedArray);

        if (value === "Billable") {
            if (btnData.classification === "W" || btnData.classification === "Work") {
                clonedArray.filter((item) => {
                    if (item.id === btnData.id) {
                        item.selected = "W";
                        item.classification = "W";
                        item.billable = btnData.billable === "N" ? "Y" : "N";
                    }
                })
                setData(clonedArray);
                var reqData1 = {
                    activityId: btnData.id,
                    customerId: btnData.customerId,
                    classification: "W",
                    billable: btnData.billable
                }
                console.log("reqData1", reqData1)

                updateActivity(reqData1);
                //   setPerCard([btnData]);
                // console.log("btndata.id", btnData.id)
                // setChildCardIds([btnData.id]);
            }
            else {
                if (!toast.isActive(toastId.current)) {
                    toastId.current = toast.warn(`Only a 'Work' type visit can be classified as 'Billable'`);
                }
            }
        } else {
            clonedArray.filter((item) => {
                if (item.id === btnData.id) {
                    item.selected = value;
                    item.classification = value;
                }
            })
            setData(clonedArray);
            var reqData = {
                activityId: btnData.id,
                customerId: btnData.customerId,
                classification: value.charAt(0),
                billable: btnData.billable
            }
            console.log("reqData", reqData)
            updateActivity(reqData);
            //  setPerCard([btnData]);
            // console.log("btndata.id", btnData.id)
            //  setChildCardIds([btnData.id]);

        }
    }
    //groupby functionality

    const onRadioBtnClick = async (p, array) => {
        setemptysearchdata(!emptysearchdata)
        setAllChecked(false);
        setCardChecked(false);
        var newData = array;
        setrSelected(p)
        setSortBy(p)
        setAfterSubmitSort(p);
        const newGroupedData = groupBy(newData, p);
        var tempArray = [];
        if (newGroupedData && newGroupedData !== undefined) {
            for (const [key, value] of Object.entries(newGroupedData).sort()) {
                let obj = {
                    date: key, //name/date/address
                    data: value // array of obj
                }
                tempArray.push(obj);
            }
            setGroupedData(tempArray)
            setActivityCard(tempArray)
        }
        handleSearchChange1(p);
    }

    //
    const handleSearchChange1 = async (p) => {
        setFilterClassification(true)
        setSearchStatus(true);
        //console.log(localStorage.getItem('searchItem'));
        if (localStorage.getItem('searchItem')) {
            var tempArray = await filterResToGroupnew(p);
            // console.log("tempArray1", tempArray)
            var value = localStorage.getItem('searchItem')
            setSearchVal(value)
            // console.log("value", value)
            // console.log("tempArray2", tempArray)
            var newArray = [];
            //search filter
            const result = tempArray.filter(obj => {
                obj.data = obj.data.filter(subElement => subElement.customerName.toLowerCase().search(value.toLowerCase()) !== -1 || subElement.formattedAddress.toLowerCase().search(value.toLowerCase()) !== -1 || subElement.formattedDate.toLowerCase().search(value.toLowerCase()) !== -1);
                if (obj.data.length > 0) {
                    //if category selected and search (match selected category with data classification)
                    obj.data = obj.data.filter(subElement => (categoryFromSummary.includes(subElement.classification) || categoryFromSummary.includes(subElement.billable)));

                    if (obj.data.length > 0) {
                        // console.log(obj);
                        return newArray.push(obj)

                    }
                }
            })
            // console.log(result);
            setActivityCard(result);
            setGroupedData(result);

        }

    }

    //

    //
    const filterResToGroupnew = async (p) => {
        //   console.log("sortBy",sortBy)
        //   console.log("search",search)
        var newData = data;
        const newGroupedData = await groupBy(newData, p);
        var tempArray = [];
        if (newGroupedData && newGroupedData !== undefined) {
            for (const [key, value] of Object.entries(newGroupedData).sort()) {
                let obj = {
                    date: key,
                    data: value
                }
                tempArray.push(obj);
            }
        }
        return tempArray;
    }

    //
    const sortGroupData = async (sort) => {
        console.log("sort", sort)
        //   alert("hello");
        setSorting(sort);
        //    setTimeout(()=>{
        console.log(groupedData)
        var newGroup = [...groupedData];
        console.log("newGroup", newGroup)

        const sortedGroup = newGroup.sort((b, a) => { return a.date - b.date; }).reverse();
        setGroupedData(sortedGroup);
        setActivityCard(sortedGroup);
        console.log("sortedGroup", sortedGroup)
        //   },3000)
        setLoading(false);
    }

    //grouping of cards by name, date, address
    function groupBy(objectArray, property) {
        if (objectArray && objectArray.length > 0) {
            return objectArray.reduce((acc, obj) => {
                const key = obj[property];
                if (!acc[key]) {
                    acc[key] = [];
                }
                // Add object to list for given key's value
                acc[key].push(obj);
                return acc;
            }, {});
        }
    }

    //on selecting date range from datepicker
    const handleDateRange = (event, dates) => {
        //     console.log("dates",dates);
        localStorage.removeItem('searchItem');
        filterCategory([]);
        setLoading(true);
        setAllChecked(false);
        setCardChecked(false);
        setPerCard([]);
        localStorage.setItem('start-date', moment(dates.startDate).format('MM/DD/YYYY'))
        localStorage.setItem('end-date', moment(dates.endDate).format('MM/DD/YYYY'))
        
        doFetch();
        doFetchSummary();
        setLoading(false);

    }

    //search functionality
    const handleSearchChange = async (e) => {

        var value = e;
        setSearchVal(e)
        var tempArray = await filterResToGroup();

        if (value.length === 0 && (categoryFromSummary.length === 4 || categoryFromSummary.length === 0)) {
            setSearchStatus(false);
            setActivityCard(tempArray);
            setGroupedData(tempArray)

        } else {
            var newArray = [];
            //search filter
            tempArray.filter(obj => {

                obj.data = obj.data.filter(subElement => subElement.customerName.toLowerCase().search(value.replace(/&(lt|gt|quot|=);\\/g, "").toLowerCase()) !== -1 || subElement.formattedAddress.toLowerCase().search(value.replace(/&(lt|gt|quot|=);\\/g, "").toLowerCase()) !== -1);
                if (obj.data.length > 0) {
                    //if category selected and search (match selected category with data classification)
                    if (filterClassification) {
                        obj.data = obj.data.filter(subElement => (categoryFromSummary.includes(subElement.classification) || categoryFromSummary.includes(subElement.billable)));
                        if (obj.data.length > 0) {
                            newArray.push(obj)
                        } else return;
                    }
                    else newArray.push(obj);
                }
            })
            setActivityCard(newArray);
            setGroupedData(newArray);

        }

    }

    //called after updating activity data child form
    const feedbackFun = (selectdata, sorting) => {
        doFetch()
        doFetchSummary();

        setAfterSubmitSort(sorting)
        if (childCardIds.length === data.length) {
            // console.log("all result selected......")
            setAllChecked(true)
        }
        childRef.current.getAlert();
    }

    const filterCategory = async (category) => {
        setAllChecked(false);
        setCardChecked(false);
        setPerCard([]);
        setDataForForm([]);
        setChildCardIds([]);
        setActivityCard([])
        var value = localStorage.getItem('searchItem');

        //  console.log("category.length",category.length);
        var newTempArray = [];
        var newArray = [];
        if (category.length === 0 || category.length === 4) {
            setCategoryFromSummary(['U', 'P', 'W', 'Y']);

            var tempArray = await filterResToGroup();

            if (localStorage.getItem('searchItem')) {
                console.log("tempArray", tempArray);
                tempArray.filter(obj => {
                    obj.data = obj.data.filter(subElement => subElement.customerName.toLowerCase().search(value.replace(/&(lt|gt|quot|=);\\/g, "").toLowerCase()) !== -1 || subElement.formattedAddress.toLowerCase().search(value.replace(/&(lt|gt|quot|=);\\/g, "").toLowerCase()) !== -1);
                    if (obj.data.length > 0) {
                        //if category selected and search (match selected category with data classification)
                        console.log("categoryFromSummarybefore", categoryFromSummary);

                        if (!filterClassification) {
                            obj.data = obj.data.filter(subElement => (categoryFromSummary.includes(subElement.classification) || categoryFromSummary.includes(subElement.billable)));
                            if (obj.data.length > 0) {
                                newArray.push(obj)
                            } else return;
                        }
                        else newArray.push(obj);
                    }
                })
                console.log("1", newArray)
                setGroupedData(newArray)
                setActivityCard(newArray)
            } else {
                console.log("2", tempArray)

                setGroupedData(tempArray)
                setActivityCard(tempArray)
            }
        } else {
            setCategoryFromSummary(category);
            setFilterClassification(true)
            var tempArray = await filterResToGroup();
            console.log("tempArray", tempArray)
            tempArray.filter(obj => {
                obj.data = obj.data.filter((subElement) =>
                    category.indexOf(subElement.classification) !== -1 || category.indexOf(subElement.billable) !== -1
                );
                if (obj.data.length > 0) {
                    newTempArray.push(obj);
                } else return;


            });
            console.log("newTempArray", newTempArray)

            if (localStorage.getItem('searchItem')) {
                var newarrayforsearch = [];

                console.log("newTempArray", newTempArray);
                newTempArray.filter(obj => {
                    obj.data = obj.data.filter(subElement => subElement.customerName.toLowerCase().search(value.replace(/&(lt|gt|quot|=);\\/g, "").toLowerCase()) !== -1 || subElement.formattedAddress.toLowerCase().search(value.replace(/&(lt|gt|quot|=);\\/g, "").toLowerCase()) !== -1);
                    if (obj.data.length > 0) {
                        console.log("categoryFromSummary", categoryFromSummary);
                        console.log("category.length", category.length);

                        //if category selected and search (match selected category with data classification)
                        if (filterClassification) {
                            obj.data = obj.data.filter(subElement => (category.includes(subElement.classification) || category.includes(subElement.billable)));
                            if (obj.data.length > 0) {
                                newarrayforsearch.push(obj)
                            } else return;
                        }
                        else newarrayforsearch.push(obj);
                    }
                })
                newTempArray.filter(obj => {
                    obj.data = obj.data.filter((subElement) =>
                        category.indexOf(subElement.classification) !== -1 || category.indexOf(subElement.billable) !== -1
                    );
                    if (obj.data.length > 0) {
                        console.log("obj.data", obj.data)
                        newarrayforsearch.push(obj);
                    } else return;

                    console.log("newarrayforsearch", newarrayforsearch);

                });
                setGroupedData(newarrayforsearch)
                setActivityCard(newarrayforsearch)
            } else {
                setGroupedData(newTempArray)
                setActivityCard(newTempArray)
            }
        }
    }

    // filtering data by summary category button
    // const filterCategory = async (category) => {
    //     setAllChecked(false);
    //     setCardChecked(false);
    //     setPerCard([]);
    //     setDataForForm([]);
    //     setChildCardIds([]);
    //     setActivityCard([])

    //     var newTempArray = [];
    //     if (category.length === 0 || category.length === 4) {
    //         setCategoryFromSummary(['U', 'P', 'W', 'Y']);

    //         var tempArray = await filterResToGroup();
    //         setGroupedData(tempArray)
    //         setActivityCard(tempArray)

    //     } else {
    //         setCategoryFromSummary(category);
    //         setFilterClassification(true)
    //         var tempArray = await filterResToGroup();
    //         tempArray.filter(obj => {
    //             obj.data = obj.data.filter((subElement) =>
    //                 category.indexOf(subElement.classification) !== -1 || category.indexOf(subElement.billable) !== -1
    //             );
    //             if (obj.data.length > 0) {
    //                 newTempArray.push(obj);
    //             } else return;
    //         });
    //         setGroupedData(newTempArray)
    //         setActivityCard(newTempArray)

    //     }
    // }
    window.onbeforeunload = function (e) {
        localStorage.removeItem('searchItem');
    };
    const filterResToGroup = async () => {
        var newData = data;
        const newGroupedData = await groupBy(newData, sortBy);
        var tempArray = [];
        if (newGroupedData && newGroupedData !== undefined) {
            for (const [key, value] of Object.entries(newGroupedData).sort()) {
                let obj = {
                    date: key,
                    data: value
                }
                tempArray.push(obj);
            }
        }
        return tempArray;
    }

    return (
        <div className="dashmaindiv" style={{ fontFamily: "Poppins" }}>
            <div style={{ width: "100%" }}>

                <Navbar />

                <Container fluid="true" style={{ alignItems: "center", justifyContent: "center", padding: "0px" }} className="containerStyle bg-white mx-auto">

                    <div className="filterDiv row">
                        {/* Date range picker*/}
                        <DateRangeComponent isLoading={isLoading} handleDateRange={handleDateRange} />

                        {/* Grouping button group */}
                        <div className="col-md-6 my-auto pr-5 text-end">
                            <small>&nbsp;Group By &nbsp;
                                <ButtonGroup size="sm">
                                    <Button className="LeftBtnStyle ActiveBtnStyle" outline color={defaultBtnStyle} onClick={() => { onRadioBtnClick("groupByDate", data); }} active={rSelected === "groupByDate"}>Date</Button>
                                    <Button className="ActiveBtnStyle" outline color={defaultBtnStyle} onClick={() => { onRadioBtnClick("groupByCustomer", data); setPerCard([]); }} active={rSelected === "groupByCustomer"}>Name</Button>
                                    <Button className="RightBtnStyle ActiveBtnStyle" outline color={defaultBtnStyle} onClick={() => { onRadioBtnClick("groupByAddress", data); }} active={rSelected === "groupByAddress"}>Address</Button>
                                </ButtonGroup>
                            </small>
                        </div>

                        {/* summary hours block */}
                        <SummaryHeader summaryData={summaryData} isSummaryLoading={isSummaryLoading} filterCategory={filterCategory} filterClassification={filterClassification} />

                    </div>

                    {/* mapping of card data */}
                    <div className="row" style={{ margin: "0 0 2.5rem 0", fontWeight: "300" }}>
                        {(loading || data.length === 0 || !data) ?
                            <div className="loadNoDataDiv" style={{ fontSize: "x-large", fontWeight: "bolder" }}>{(!loading && activityCard.length === 0 && groupedData.length === 0) ? "No data available" : <span style={{ color: "#2596BE" }}>
                                <FaSpinner icon="spinner" spin={"true"} style={{ animation: "spin infinite 5s linear" }} />&nbsp;
                                Loading...</span>}
                            </div>
                            : <>
                                <div className="col-md-9" style={{ padding: "0px", backgroundColor: "#ebe7e7" }}>

                                    {/* SearchBar */}
                                    <SearchBar handleSearchChange={handleSearchChange} emptygroup={emptysearchdata} category={categoryFromSummary} />

                                    {((data && data.length > 0 && groupedData && groupedData.length > 0) || (searchStatus && activityCard && activityCard.length > 0) && !loading) ?
                                        <>
                                            <div className="row" style={{ border: "1px solid lightgrey", paddingBlock: "5px", margin: "0px", backgroundColor: "white", alignSelf: 'center !important' }}>

                                                {/* all result checkbox */}
                                                <div className="col p-0">
                                                    <small style={{ marginLeft: "10px", verticalAlign: "middle" }}>
                                                        <input type="checkbox" onChange={() => { checkingCard("all"); setPerCard([]); setCardChecked(false); }} checked={allChecked} />
                                                        &nbsp;All results
                                                    </small>
                                                </div>

                                                {/* Sorting the groups */}
                                                <div className="col p-0" onClick={() => {
                                                    setLoading(true);
                                                    sortGroupData(!sorting);
                                                }}
                                                    className="sortByDiv"
                                                >
                                                    <Sortby sortProps={sorting} />
                                                </div>

                                            </div>

                                            {/* Grouped activities */}
                                            {data && data.length > 0 && groupedData.length > 0 && activityCard.length > 0 && activityCard.map((gdata, index) =>
                                                <div>
                                                    <div key={index} style={{ backgroundColor: "#d3d3d336", border: "1px solid darkgrey", marginBlock: "2px", display: gdata?.data[0] ? '' : 'none' }}>
                                                        {/* group header */}
                                                        <div style={{ fontSize: "12.8px", padding: "5px 1px", display: "flex", placeContent: "space-between", backgroundColor: "#f7f7f7" }}>

                                                            <span key={gdata.date} style={{ paddingLeft: "6px", color: "#2596BE", borderRight: "1px solid lightrey" }} >
                                                                <label className="customCheck">&nbsp;&nbsp;{(sortBy === "groupByDate") ? moment(gdata.date).format('dddd, MMM DD, YYYY') : gdata.date}
                                                                    <input type="checkbox" style={{ verticalAlign: "middle" }} onChange={() => { checkingCard(gdata) }} checked={allChecked || (gdata.date === (cardChecked || dateForGroup))} />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </span>

                                                            <span style={{ paddingRight: "1rem", fontWeight: "bold", marginBlock: "auto" }}>(Duration Total - {sortBy === "groupByCustomer" ? gdata?.data[0]?.hoursByCustomer : [sortBy === "groupByDate" ? gdata?.data[0]?.hoursByDate : gdata?.data[0]?.hoursByAddress]})</span>
                                                        </div>


                                                        {/* Group data */}
                                                        {gdata.data.length > 0 && gdata.data.map((item, index) => (
                                                            <div key={index} style={{ display: "flex", borderTop: "1px solid lightgrey", padding: "2px 1px", placeContent: "space-between", backgroundColor: "white" }}>
                                                                {/* Group header */}
                                                                <div style={{ flex: sortBy === "groupByCustomer" ? 0.02 : 0.8, textAlign: "left", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "" }} className="smallFont">
                                                                    {/* checkbox */}
                                                                    <input type="checkbox" style={{ verticalAlign: "middle" }} onChange={() => perDataCard(item)} checked={(childCardIds.includes(item.id) || item.groupByDate === (cardChecked || dateForGroup) || item.groupByCustomer === cardChecked || item.groupByAddress === cardChecked || allChecked || perCard.some(obj => obj.id === item.id) || (perCard.includes(item.id)) ? true : false)} />
                                                                    &nbsp;
                                                                    {/* activity name */}
                                                                    <span style={{ flex: .4, display: sortBy === "groupByCustomer" ? "none" : "" }}>&nbsp;{item.customerName}</span>
                                                                </div>

                                                                {/* Group data */}
                                                                {/* date */}
                                                                <div style={{ flex: .6, display: sortBy === "groupByDate" ? "none" : "" }} className="smallFont flexCss" >{moment(item.groupByDate).format('ddd, MMM DD, YYYY')}</div>
                                                                {/* Address */}
                                                                <Tooltip radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div style={{ fontSize: "x-small" }}>{item.formattedAddress}</div>}>
                                                                    <div style={{ flex: 1.2, overflow: "hidden !important", whiteSpace: "nowrap !important", textOverflow: "ellipsis !important", cursor: "pointer", display: sortBy === "groupByAddress" ? "none" : "" }} className="smallFont flexCss" >{item.formattedAddress}</div>
                                                                </Tooltip>
                                                                {/* Time */}
                                                                <div style={{ flex: .8, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} className="smallFont">{item.displayTime}</div>
                                                                {/* Duration */}
                                                                <div style={{ flex: .4, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} className="smallFont"><b>{item.duration}</b></div>
                                                                {/* classification buttons */}
                                                                <div style={{ flex: sortBy === "groupByAddress" ? 0.7 : .8, display: "flex", justifyContent: "flex-end", paddingRight: "1rem" }}>
                                                                    {/* Unclassified */}
                                                                    {(item.classification === "U" || item.selected === "Unclassified") ?
                                                                        <Tooltip radius="5" arrow="5" placement="bottom" overlay={<div style={{ fontSize: "x-small" }}>Unclassified</div>}>
                                                                            <span style={{ backgroundColor: "#dcdcdc", height: "fitContent" }} className="icon-circle unclassifiedBtn btn-hover-none" onClick={() => { myFun("Unclassified", item); }}><img src={ufilled} height="20px" width="20px" alt="qmark" /><span style={{ fontSize: ".8em", fontWeight: "500" }}></span>
                                                                            </span>
                                                                        </Tooltip>
                                                                        :
                                                                        <Tooltip radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div style={{ fontSize: "x-small" }}>Unclassified</div>}>
                                                                            <span style={{ backgroundColor: "white", height: "fitContent", border: "1px solid rgba(112, 101, 101, 0.5) " }} className="icon-circle unclassifiedBtn" onClick={() => { myFun("Unclassified", item); }} ><img src={(item?.selected === "Unclassified" && "Unclassified") ? ufilled : u} height="20px" width="20px" alt="qmark2" /><span style={{ fontSize: ".8em", fontWeight: "500" }}>{item?.selected === "Unclassified" && "Unclassified"}</span>
                                                                            </span>
                                                                        </Tooltip>
                                                                    }

                                                                    {/* Personal */}
                                                                    {(item.classification === "P" || item.selected === "Personal") ?
                                                                        <Tooltip radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div style={{ fontSize: "x-small" }}>Personal</div>}><span style={{ backgroundColor: "#E1EBEF", height: "fitContent" }} className="icon-circle personalBtn btn-hover-none" onClick={() => { myFun("Personal", item); }} ><img src={HomeIcon2} height="20px" width="20px" alt="home" /><span style={{ fontSize: ".8em", fontWeight: "500" }}></span></span></Tooltip>
                                                                        :
                                                                        <Tooltip radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div style={{ fontSize: "x-small" }}>Personal</div>}><span style={{ backgroundColor: "white", height: "fitContent", border: "1px solid rgba(13, 117, 153, 0.5)" }} className="icon-circle personalBtn" onClick={() => { myFun("Personal", item); }}><img src={item?.selected === "Personal" && "Personal" ? HomeIcon2 : HomeIcon} height="20px" width="20px" alt="home2" /><span style={{ fontSize: ".8em", fontWeight: "500" }}>{item?.selected === "Personal" && "Personal"}</span></span></Tooltip>
                                                                    }
                                                                    {/* Work */}
                                                                    {(item.classification === "W" || item.selected === "Work") ?
                                                                        <Tooltip radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div style={{ fontSize: "x-small" }}>Work</div>}><span style={{ backgroundColor: "#CAECE5", height: "fitContent" }} className="icon-circle workBtn btn-hover-none" onClick={() => { myFun("Work", item); }}><img src={BriefCase2} height="20px" width="20px" alt="work" /><span style={{ fontSize: ".8em", fontWeight: "500" }}></span></span></Tooltip>
                                                                        :
                                                                        <Tooltip radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div style={{ fontSize: "x-small" }}>Work</div>}><span style={{ backgroundColor: "white", height: "fitContent", border: "1px solid rgba(0, 117, 94, 0.5)" }} className="icon-circle workBtn" onClick={() => { myFun("Work", item); }}><img src={item?.selected === "Work" && "Work" ? BriefCase2 : BriefCase} height="20px" width="20px" alt="work" /><span style={{ fontSize: ".8em", fontWeight: "500" }}>{item?.selected === "Work" && "Work"}</span></span></Tooltip>
                                                                    }
                                                                    {/* Billable */}
                                                                    {(item.billable === "Y") && (item.classification === "W" || item.selected === "Work") ?
                                                                        <Tooltip radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div style={{ fontSize: "x-small" }}>Billable</div>}><span style={{ backgroundColor: "#FCEFEE", height: "fitContent" }} className=" billingBtn btn-hover-none" onClick={() => { myFun("Billable", item); }}><img src={dollarfilled} height="20px" width="20px" alt="bill" /><span style={{ fontSize: ".8em", fontWeight: "500" }}></span></span></Tooltip>
                                                                        :
                                                                        <Tooltip radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div style={{ fontSize: "x-small" }}>Billable</div>}><span style={{ backgroundColor: "white", height: "fitContent", border: "1px solid rgba(187, 36, 31, 0.5)" }} className=" billingBtn" onClick={() => { myFun("Billable", item); }}><img src={dollar} height="20px" width="20px" alt="bill" /></span></Tooltip>
                                                                    }
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>)
                                            }
                                        </>
                                        : <div className="loadNoDataDiv" style={{ backgroundColor: 'white' }}>No data available</div>
                                    }
                                </div>
                                <div className="col-md-3" style={{ borderRight: "1px solid lightgrey", padding: "0px" }}>
                                    {(childCardIds?.length === 0 || childCardIds === undefined) ?
                                        <div className="sidediv1" style={{ color: "#2596BE", textDecoration: "underline" }}><h6>Select Visit(S) To Modify</h6></div> :
                                        <div className="sidediv2">
                                            {/* Google map */}
                                            <GoogleMap data={data.filter((elem) => childCardIds.find((id) => elem.id === id))?.filter(mapCoord => mapCoord.coordinate)} />
                                            {/* Update Activity Form */}
                                            <MapForm data={data.filter((elem) => childCardIds.find((id) => elem.id === id))} cardIDs={childCardIds} sortBy={sortBy} updateState={feedbackFun} ref={childRef} />
                                        </div>}
                                </div></>}
                    </div>

                    <ToastContainer />
                    <ScrollButton />
                    <IdleMonitor />

                </Container>
                <Footer />

            </div>

        </div>

    );
}

export default Dashboard;